<template>
    <div v-if="stage" class="px-4">
        <v-row>
            <v-col>
                <v-select
                v-model="stage.entity_type_id"
                :items="available_types"
                label="Tipo de registro a crear"
                item-text="name" 
                item-value="uuid"
                outlined
                hide-details="auto"
                @change="reset_payload"
                >
                </v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    v-model="stage.save_as_key"
                    label="Clave de guardado"
                    outlined
                    hide-details="auto"
                    :error="showErrors && !stage.save_as_key"
                    :background-color="showErrors && !stage.save_as_key ? '#DC0B0B1A' : 'white'"
                    @change="computeStage">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col v-if="stage.entity_type_id" >
                <RecursivePayloadOfAdressesOnSchemaEditor 
                    :key="stage.entity_type_id+'_noseque'"
                    :schema="current_type.schema" 
                    :key_to_show="current_type.name"
                    :my_bag="my_bag"
                    v-model="stage.payload_of_addresses" />
            </v-col>
        </v-row>
        
    </div>
</template>

<script>
import { CreateInstanceFromContext } from '@/modules/document/domain/WorkflowTemplate';
import { DOCS_FIELD_MAP_SHOW } from "@/modules/document/domain/Document";
import RecursivePayloadOfAdressesOnSchemaEditor from '@/modules/document/infra/RecursivePayloadOfAdressesOnSchemaEditor.vue';
// import RouteInBagSelectorComponent from '@/modules/document/infra/RouteInBagSelectorComponent';
// import { get_tree_from_schema } from '@/modules/entities/domain/GetTreeFromSchema';
export default {
    name:'CreateInstanceFromContextDetailComponent',
    components: {
        // RouteInBagSelectorComponent
        RecursivePayloadOfAdressesOnSchemaEditor
    },
    props:{
        stage: {
            type: CreateInstanceFromContext,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        available_types: {
            type: Array,
            default: () => []
        },
        my_bag:{
            type: Object,
            required: false,
            default: () => {}
        }
    },
    data(){
        return {
            cssLink: null,
            selected_schema: null
        }
    },
    mounted(){
        console.log(this.stage);
        // this.cssLink = document.createElement('link');
        // this.cssLink.rel = 'stylesheet';
        // this.cssLink.href = 'https://unpkg.com/json-schema-editor-vue/lib/json-schema-editor-vue.css';
        // document.head.appendChild(this.cssLink);
    },
    methods:{
        formatField(field) {
            return DOCS_FIELD_MAP_SHOW[field] || field;
        },
        
        computeStage(){
            this.$emit('compute-stage');
        },
        reset_payload(){
            console.log('reset');
            this.stage.payload_of_addresses = {};
        }
        
    },
    computed:{
        current_type(){
            if (!this.stage.entity_type_id){
                return {'name':'', 'schema':{}};
            }
            let current_type = this.available_types.find(e => e.uuid === this.stage.entity_type_id);
            return current_type;
        },
        // get_context_from_output_type(){
        //     if (this.stage.entity_type_id){
        //         let e_type = this.available_types.find(e => e.uuid === this.stage.entity_type_id);
        //         return get_tree_from_schema(e_type.schema);
        //     }
        //     else{
        //         return {};
        //     }
        // }
    },
    beforeDestroy() {
        // Remove the stylesheet when the component is destroyed
        // if (this.cssLink && document.head.contains(this.cssLink)) {
        // document.head.removeChild(this.cssLink);
        // }
    }
}
</script>

<style scoped >
/*@import url('https://unpkg.com/json-schema-editor-vue@2.3.0/lib/json-schema-editor-vue.css');*/
.preaty__card {
    border-radius: 5px;
}
.small_scrollbar >>> textarea {
    scrollbar-width: thin;
}
.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}
</style>